import { apiCall, createResponseBody } from './helper';

export function upsertResponse(question, submission, response) {
  return apiCall('/responses', 'POST', createResponseBody(question, submission, response));
}
